import { render, staticRenderFns } from "./block-rental-details.vue?vue&type=template&id=5f763586&scoped=true"
import script from "./block-rental-details.vue?vue&type=script&lang=js"
export * from "./block-rental-details.vue?vue&type=script&lang=js"
import style0 from "./block-rental-details.vue?vue&type=style&index=0&id=5f763586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f763586",
  null
  
)

export default component.exports